var React = require('react');

function SkewedRectangeLocal (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M10 30.223L44.896 204l241.138-34.658L310 9 10 30.223z","stroke":"#FAF0F7","strokeWidth":"15"}));
}

SkewedRectangeLocal.defaultProps = {"width":"319","height":"213","viewBox":"0 0 319 213","fill":"none"};

module.exports = SkewedRectangeLocal;

SkewedRectangeLocal.default = SkewedRectangeLocal;
